import { defineMessages } from '@transcend-io/internationalization';

export const selectDataSubjectTypeMessages = defineMessages(
  'privacy-center.components.SelectDataSubjectType.selectDataSubjectType',
  {
    selectDataSubjectType: {
      defaultMessage: 'Select which of the following applies to you',
      description:
        'The label text displayed for data subject type selection dropdown',
    },
  },
);
